import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  ApproveReportInput,
  CompleteBatchReportUploadInput,
  CompleteBatchReportUploadOutput,
  DeleteReportInput,
  ETagsList,
  InitiateBatchReportUploadInput,
  InitiateBatchReportUploadOutput,
  RejectReportInput,
  SearchReportsInput,
  UploadReportInput,
  GenerateReportAsyncInput,
  GenerateReportAsyncOutput,
  GeneratePresignedUrlInput,
  GeneratePresignedUrlOutput,
} from '@amzn/coral_com-amazon-transreportscenterservice';

import {
  SEARCH_REPORTS_REQUEST,
  SEARCH_REPORTS_SUCCESS,
  SEARCH_REPORTS_FAILURE,
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAILURE,
  GET_TERM_REPORT_CONFIGS_REQUEST,
  GET_TERM_REPORT_CONFIGS_SUCCESS,
  GET_TERM_REPORT_CONFIGS_FAILURE,
  SELECT_LP,
  SET_SEARCH_REPORTS_PAGE_SIZE,
  INITIATE_BULK_UPLOAD_FILES_REQUEST,
  INITIATE_BULK_UPLOAD_FILES_SUCCESS,
  INITIATE_BULK_UPLOAD_FILES_FAILURE,
  FILE_PARTS_UPLOAD_REQUEST,
  FILE_PARTS_UPLOAD_SUCCESS,
  FILE_PARTS_UPLOAD_FAILURE,
  COMPLETE_BULK_UPLOAD_FILES_REQUEST,
  COMPLETE_BULK_UPLOAD_FILES_SUCCESS,
  COMPLETE_BULK_UPLOAD_FILES_FAILURE,
  UPLOAD_FILE_FOLDER_REQUEST,
  UPLOAD_FILE_FOLDER_SUCCESS,
  UPLOAD_FILE_FOLDER_FAILURE,
  SET_CURRENT_FOLDER_PATH,
  SET_CURRENT_PAGE,
  DELETE_REPORT_REQUEST,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAILURE,
  RESET_IS_TRIGGER_SEARCH_REPORT,
  RESET_BULK_FILES_PART_STATE,
  BULK_DOWNLOAD_REPORTS_REQUEST,
  BULK_DOWNLOAD_REPORTS_SUCCESS,
  BULK_DOWNLOAD_REPORTS_FAILURE,
  SET_REPORT_SELECTION,
  SET_SORT_CRITERIA,
  GENERATE_REPORT_ASYNC_REQUEST,
  GENERATE_REPORT_ASYNC_SUCCESS,
  GENERATE_REPORT_ASYNC_FAILURE,
  RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC,
  GENERATE_PRESIGNED_URL_REQUEST,
  GENERATE_PRESIGNED_URL_SUCCESS,
  GENERATE_PRESIGNED_URL_FAILURE,
  SET_DDU_LIST,
  PREVIEW_ENABLED,
  GET_DOWNLOAD_REPORT_URL_REQUEST,
  GET_DOWNLOAD_REPORT_URL_SUCCESS,
  GET_DOWNLOAD_REPORT_URL_FAILURE,
  FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS,
  FETCH_DATA_FROM_PRESIGNED_URL_FAILURE,
  FETCH_DATA_FROM_PRESIGNED_URL_REQUEST,
  RESET_REPORT_LIST,
  GET_REPORT_DETAILS_REQUEST,
  GET_REPORT_DETAILS_SUCCESS,
  GET_REPORT_DETAILS_FAILURE,
  APPROVE_REPORT_REQUEST,
  APPROVE_REPORT_SUCCESS,
  APPROVE_REPORT_FAILURE,
  REJECT_REPORT_REQUEST,
  REJECT_REPORT_SUCCESS,
  REJECT_REPORT_FAILURE,
  RESET_GET_REPORT_DETAILS,
  SET_FILTER_SHEET_OPEN,
  SET_FILTERS,
  START_GET_REPORT_DETAILS_POLLING_REQUEST,
  STOP_GET_REPORT_DETAILS_POLLING_REQUEST,
  GET_PRESIGNED_URL_REQUEST,
  GET_PRESIGNED_URL_SUCCESS,
  GET_PRESIGNED_URL_FAILURE,
} from './types';

import { BulkDownloadReportsRequest } from './typeDefs';

export const searchReports = createAsyncAction(
  SEARCH_REPORTS_REQUEST,
  SEARCH_REPORTS_SUCCESS,
  SEARCH_REPORTS_FAILURE
)();

export const downloadReport = createAsyncAction(
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAILURE
)();

export const bulkDownloadReports = createAsyncAction(
  BULK_DOWNLOAD_REPORTS_REQUEST,
  BULK_DOWNLOAD_REPORTS_SUCCESS,
  BULK_DOWNLOAD_REPORTS_FAILURE
)<BulkDownloadReportsRequest, null, null>();

export const setReportSelection =
  createAction(SET_REPORT_SELECTION)<Array<string>>();

export const getTermReportConfigs = createAsyncAction(
  GET_TERM_REPORT_CONFIGS_REQUEST,
  GET_TERM_REPORT_CONFIGS_SUCCESS,
  GET_TERM_REPORT_CONFIGS_FAILURE
)();

export const selectLp = createAction(SELECT_LP)();

export const setSearchReportsPageSize = createAction(
  SET_SEARCH_REPORTS_PAGE_SIZE
)();
export const setCurrentFolderPath = createAction(SET_CURRENT_FOLDER_PATH)();
export const setCurrentPage = createAction(SET_CURRENT_PAGE)();
export const setSortCriteria = createAction(SET_SORT_CRITERIA)();
export const resetReportsList = createAction(RESET_REPORT_LIST)();
export const setFilterSheetOpenAction = createAction(SET_FILTER_SHEET_OPEN)();
export const setFiltersAction = createAction(SET_FILTERS)();

export const initiateBulkUploadFilesAction = createAsyncAction(
  INITIATE_BULK_UPLOAD_FILES_REQUEST,
  INITIATE_BULK_UPLOAD_FILES_SUCCESS,
  INITIATE_BULK_UPLOAD_FILES_FAILURE
)<
  {
    initiateBatchReportUploadInput: InitiateBatchReportUploadInput;
    files: Array<File>;
  },
  {
    initiateBatchReportUploadOutput: InitiateBatchReportUploadOutput;
  },
  null
>();

export const filePartsUploadAction = createAsyncAction(
  FILE_PARTS_UPLOAD_REQUEST,
  FILE_PARTS_UPLOAD_SUCCESS,
  FILE_PARTS_UPLOAD_FAILURE
)<
  {
    partUploadRequests: Array<any>;
    uploadId: String;
  },
  {
    eTags: ETagsList;
    key: String;
  },
  {
    key: String;
  }
>();

export const completeBulkUploadFilesAction = createAsyncAction(
  COMPLETE_BULK_UPLOAD_FILES_REQUEST,
  COMPLETE_BULK_UPLOAD_FILES_SUCCESS,
  COMPLETE_BULK_UPLOAD_FILES_FAILURE
)<
  {
    completeBatchReportUploadInput: CompleteBatchReportUploadInput;
  },
  {
    completeBatchReportUploadOutput: CompleteBatchReportUploadOutput;
  },
  null
>();

export const resetBulkFilesPartState = createAction(
  RESET_BULK_FILES_PART_STATE
)();

export const resetIsTriggerSearchReportState = createAction(
  RESET_IS_TRIGGER_SEARCH_REPORT
)();

export const uploadFileFolderAction = createAsyncAction(
  UPLOAD_FILE_FOLDER_REQUEST,
  UPLOAD_FILE_FOLDER_SUCCESS,
  UPLOAD_FILE_FOLDER_FAILURE
)<
  {
    uploadReportInput: UploadReportInput;
  },
  null,
  null
>();

export const deleteReportAction = createAsyncAction(
  DELETE_REPORT_REQUEST,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAILURE
)<
  {
    deleteReportInput: DeleteReportInput;
  },
  null,
  null
>();

export const generateReportAsync = createAsyncAction(
  GENERATE_REPORT_ASYNC_REQUEST,
  GENERATE_REPORT_ASYNC_SUCCESS,
  GENERATE_REPORT_ASYNC_FAILURE
)<
  {
    generateReportAsyncInput: GenerateReportAsyncInput;
  },
  {
    generateReportAsyncOutput: GenerateReportAsyncOutput;
  },
  null
>();

export const resetIsTriggerGenerateReportAsync = createAction(
  RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC
)();

export const reportPreviewEnabled = createAction(PREVIEW_ENABLED)();

export const generatePresignedUrl = createAsyncAction(
  GENERATE_PRESIGNED_URL_REQUEST,
  GENERATE_PRESIGNED_URL_SUCCESS,
  GENERATE_PRESIGNED_URL_FAILURE
)<
  {
    generatePresignedUrlInput: GeneratePresignedUrlInput;
  },
  {
    generatePresignedUrlOutput: GeneratePresignedUrlOutput;
  },
  null
>();

export const setDDUList =
  createAction(SET_DDU_LIST)<{ value: string; label: string }[]>();

export const downloadReportPresignedURL = createAsyncAction(
  GET_DOWNLOAD_REPORT_URL_REQUEST,
  GET_DOWNLOAD_REPORT_URL_SUCCESS,
  GET_DOWNLOAD_REPORT_URL_FAILURE
)();

export const fetchDataFromPresignedURL = createAsyncAction(
  FETCH_DATA_FROM_PRESIGNED_URL_REQUEST,
  FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS,
  FETCH_DATA_FROM_PRESIGNED_URL_FAILURE
)<
  {
    presignedUrl: string;
  },
  null,
  null
>();

export const getReportDetailsAction = createAsyncAction(
  GET_REPORT_DETAILS_REQUEST,
  GET_REPORT_DETAILS_SUCCESS,
  GET_REPORT_DETAILS_FAILURE
)<{ getReportDetailsInput: SearchReportsInput }, null, null>();

export const resetGetReportDetailsState = createAction(
  RESET_GET_REPORT_DETAILS
)();

export const approveReportAction = createAsyncAction(
  APPROVE_REPORT_REQUEST,
  APPROVE_REPORT_SUCCESS,
  APPROVE_REPORT_FAILURE
)<
  {
    approveReportInput: ApproveReportInput;
  },
  null,
  null
>();

export const rejectReportAction = createAsyncAction(
  REJECT_REPORT_REQUEST,
  REJECT_REPORT_SUCCESS,
  REJECT_REPORT_FAILURE
)<
  {
    rejectReportInput: RejectReportInput;
  },
  null,
  null
>();

export const startReportDetailsPollingAction = createAction(
  START_GET_REPORT_DETAILS_POLLING_REQUEST
)<{ getReportDetailsInput: SearchReportsInput }>();

export const stopReportDetailsPollingAction = createAction(
  STOP_GET_REPORT_DETAILS_POLLING_REQUEST
)();

export const getPresignedUrl = createAsyncAction(
  GET_PRESIGNED_URL_REQUEST,
  GET_PRESIGNED_URL_SUCCESS,
  GET_PRESIGNED_URL_FAILURE
)<
  {
    getPresignedUrlInput: GeneratePresignedUrlInput;
    triggerDownload?: boolean;
  },
  {
    getPresignedUrlOutput: GeneratePresignedUrlOutput;
  },
  null
>();
